// extracted by mini-css-extract-plugin
export default {"btop":"_52cb08e2fc _9e7807b99c _47d8a4a61a","icon":"_8ff874ef7b _241ca8964b","btoppink":"_7453733a34 _950911b975"};